
import { Link, useLocation } from 'react-router-dom';
import { FaRegCircle } from "react-icons/fa";
import { useEffect, useState } from 'react';

function Sidebar(){
  const location = useLocation();
  const [selectedPage,setSelectedPage] = useState()

  useEffect(()=>{
    let page = location.pathname.split('/')[1]
    setSelectedPage(page)
  },[location])


    return (
        <aside className="sidebar">
        <ul className="sidebar-menu">
          <li className={`${selectedPage=='courses'?'selected':''}`}>
            <Link to={'/courses'}>
              <img src="/Images/Icons/menu-icons/course.svg"/>
              <span className="item-tooltip">Təlimlər</span>
            </Link>
          </li>
          <li className={`${selectedPage=='branches'?'selected':''}`}>
            <Link to={'/branches'}>
              <img src="/Images/Icons/menu-icons/branch.svg"/>
              <span className="item-tooltip">Filiallar</span>
            </Link>
          </li>
          <li className={`${selectedPage=='requests'?'selected':''}`}>
            <Link to={'/requests'}>
              <img src="/Images/Icons/menu-icons/request.svg"/>
              <span className="item-tooltip">Müraciətlər</span>
            </Link>
          </li>
          <li className={`${selectedPage=='candidates'?'selected':''}`}>
            <Link to={'/candidates'}>
              <img src="/Images/Icons/menu-icons/candidate.svg"/>
              <span className="item-tooltip">Namizədlər</span>
            </Link>
          </li>
          <li className={`${selectedPage=='groups'?'selected':''}`}>
            <Link to={'/groups'}>
            <img src="/Images/Icons/menu-icons/group.svg"/>
            <span className="item-tooltip">Qruplar</span>
            </Link>
          </li>
          <li className={`${selectedPage=='students'?'selected':''}`}>
            <Link to={'/students'}>
            <img src="/Images/Icons/menu-icons/student.svg"/>
            <span className="item-tooltip">İştirakçılar</span>
            </Link>
          </li>
          <li className={`${selectedPage=='teachers'?'selected':''}`}>
            <Link to={'/teachers'}>
            <img src="/Images/Icons/menu-icons/teacher.svg"/>
            <span className="item-tooltip">Müəllimlər</span>
            </Link>
          </li>
          <li className={`${selectedPage=='classes'?'selected':''}`}>
            <Link to={'/classes'}>
            <img src="/Images/Icons/menu-icons/class.svg"/>
            <span className="item-tooltip">Dərslər</span>
            </Link>
          </li>
          <li className={`${selectedPage=='examTypes'?'selected':''}`}>
            <Link to={'/examTypes'}>
            <img src="/Images/Icons/menu-icons/examType.svg"/>
            <span className="item-tooltip">İmtahan növləri</span>
            </Link>
          </li>
          <li className={`${selectedPage=='exams'?'selected':''}`}>
            <Link to={'/exams'}>
            <img src="/Images/Icons/menu-icons/exam.svg"/>
            <span className="item-tooltip">İmtahanlar</span>
            </Link>
          </li>
          <li className={`${selectedPage=='payments'?'selected':''}`}>
            <Link to={'/payments'}>
            <img src="/Images/Icons/menu-icons/payment.svg"/>
            <span className="item-tooltip">Ödənişlər</span>
            </Link>
          </li>
          <li className={`${selectedPage=='expenses'?'selected':''}`}>
            <Link to={'/expenses'}>
            <img src="/Images/Icons/menu-icons/expense.svg"/>
            <span className="item-tooltip">Xərclər</span>
            </Link>
          </li>
          <li className={`${selectedPage=='reports'?'selected':''}`}>
            <Link to={'/reports'}>
            <img src="/Images/Icons/menu-icons/report.svg"/>
            <span className="item-tooltip">Hesabatlar</span>
            </Link>
          </li>
          {1>2 && <li>
            <Link to={'/settings'}>
            <img src="/Images/Icons/menu-icons/settings.svg"/>
            <span className="item-tooltip">Ayarlar</span>
            </Link>
          </li>}
        </ul>
          <Link className="logo" to={"/"}>
            <img src="/Images/Logos/app_icon.svg"/>
          </Link>
      </aside>
    )
}

export default Sidebar;